import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.query<SearchFederationUsersResponse, { page: number; search: string }>({
    query: (body) => ({
      url: `v5/federation/users/search?query=${body.search}&page=${body.page}`,
      method: 'GET',
    }),
  });

export interface SearchFederationUsersResponse {
  data: SearchedUser[];
  meta?: {
    total?: number;
    page?: number;
  };
}

export interface SearchedUser {
  id: number;
  name: string;
  phone_number: number;
  email: string;
}
